import React from 'react';
import {imageUrl} from '../../utilities/requests';


const WrappingInvoice = ({school, examination, onLoad}) => <span>
    <div
        style={{
            float: 'right',
            margin: '.5cm',
            width: '13.8cm',
            height: '19.9cm',
            border: '1px solid black',
            boxSizing: 'border-box',
            pageBreakAfter: 'always',
        }}>
        <div style={{float: 'left', margin: '.5cm'}}>
            <img
                src="image/logo2.png"
                height="80"
                type="contain"
                onLoad={onLoad}
            />
        </div>
        <div style={{marginTop: '3.5cm', marginRight: '2cm', marginLeft: '2cm'}}>
            <div style={{fontSize: '32pt', fontWeight: '700', textAlign: 'center'}}>
                دفترچه سؤال
            </div>
            <br/>
            <div style={{fontSize: '24pt'}}>
                مدرسه: <b>{school.name}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                پایه: <b>{examination.grades.length ? examination.grades[0].title : '-'}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                آزمون: <b>{examination.title}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                کد بسته: <b>{school.id.persian()}</b>
            </div>
        </div>
    </div>
    <div
        style={{
            float: 'right',
            margin: '.5cm',
            width: '13.8cm',
            height: '19.9cm',
            border: '1px solid black',
            boxSizing: 'border-box',
        }}>
        <div style={{float: 'left', margin: '.5cm'}}>
            <img
                src="image/logo2.png"
                height="80"
                type="contain"
            />
        </div>
        <div style={{marginTop: '3.5cm', marginRight: '2cm', marginLeft: '2cm'}}>
            <div style={{fontSize: '32pt', fontWeight: '700', textAlign: 'center'}}>
                دفترچه پاسخ
            </div>
            <br/>
            <div style={{fontSize: '24pt'}}>
                مدرسه: <b>{school.name}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                پایه: <b>{examination.grades.length ? examination.grades[0].title : '-'}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                آزمون: <b>{examination.title}</b>
            </div>
            <div style={{fontSize: '24pt'}}>
                کد بسته: <b>{school.id.persian()}</b>
            </div>
        </div>
    </div>
</span>;

export default WrappingInvoice;
